import React from 'react';
import styled from 'styled-components/macro';
import CircularProgress from '@material-ui/core/CircularProgress';

const SLayout = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
`;

const GlobalLoading = (props) => {
    return (
        <SLayout>
            <CircularProgress size={60} />
        </SLayout>
    );
};

export default GlobalLoading;
